var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 13.417H7.875C7.39667 13.417 7 13.0203 7 12.542C7 12.0637 7.39667 11.667 7.875 11.667H17.2083C17.6867 11.667 18.0833 12.0637 18.0833 12.542C18.0833 13.0203 17.6867 13.417 17.2083 13.417Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.542 18.0833C12.0637 18.0833 11.667 17.6867 11.667 17.2083V7.875C11.667 7.39667 12.0637 7 12.542 7C13.0203 7 13.417 7.39667 13.417 7.875V17.2083C13.417 17.6867 13.0203 18.0833 12.542 18.0833Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 25.0833H9.04167C2.70667 25.0833 0 22.3767 0 16.0417V9.04167C0 2.70667 2.70667 0 9.04167 0H16.0417C22.3767 0 25.0833 2.70667 25.0833 9.04167V16.0417C25.0833 22.3767 22.3767 25.0833 16.0417 25.0833ZM9.04167 1.75C3.66333 1.75 1.75 3.66333 1.75 9.04167V16.0417C1.75 21.42 3.66333 23.3333 9.04167 23.3333H16.0417C21.42 23.3333 23.3333 21.42 23.3333 16.0417V9.04167C23.3333 3.66333 21.42 1.75 16.0417 1.75H9.04167Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationAdd);
export default __webpack_public_path__ + "static/media/reservation-add.0ad3d782ce6867f265a34b69b88e339a.svg";
export { ForwardRef as ReactComponent };